import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';

const Result = () => {
    const location = useLocation();
    const formData = location.state.biodata;
    const [data, setData] = useState(formData);
    const [fileGenerated, setFileGenerated] = useState(false);
    let intervalId; 
    const [imageUrl, setImageUrl] = useState(null);

    const getBiodataImageFile = async () => {
        try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/return_biodata_image`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: data.id }), // Ensure body is stringified
        });

        if (!response.ok) {
            throw new Error('Failed to fetch image');
        }

        const blob = await response.blob(); // Get response as Blob
        const url = URL.createObjectURL(blob); // Create object URL from Blob
        setImageUrl(url); // Set URL to state
        setFileGenerated(true); // Set fileGenerated to true since image is generated
        } catch (error) {
        console.error('Error fetching image:', error);
        // Handle error if necessary
        }
    };


    // const gettingGeneratedImageAndPdf = async () => {
    //     const response = await fetch('https://api.mangalpatrika.com/pdf_urls', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: { id: data.id },
    //     });
    //     const responseData = await response.json();
    // }    

    const getFilesGenerationsStatus = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/check_files_statuses/${data.id}`);
        const responseData = await response.json();
    
        setFileGenerated(responseData.success);
    
        if (responseData.success) {
          clearInterval(intervalId);
          await getBiodataImageFile()
        }

      };
    
      useEffect(() => {
        intervalId = setInterval(getFilesGenerationsStatus, 5000);
    
        return () => clearInterval(intervalId);
      }, []);


    const gettingGeneratedImage = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/return_biodata_image`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: data.id }), // Ensure body is stringified
        });

        const blob = await response.blob(); // Get response as Blob

        // Create a Blob URL
        const blobUrl = URL.createObjectURL(blob);

        // Extract filename from custom response header
        const filename = response.headers.get('X-Filename');

        // Create a temporary anchor element for downloading
        const tempAnchor = document.createElement('a');
        tempAnchor.href = blobUrl;
        tempAnchor.download = filename; // Set the filename for download

        // Append the anchor element to the body and programmatically click it to trigger download
        document.body.appendChild(tempAnchor);
        tempAnchor.click();

        // Remove the anchor element after download
        document.body.removeChild(tempAnchor);
    };


    const gettingGeneratedPdf = async () => {


        const response = await fetch(`${process.env.REACT_APP_API_URL}/return_biodata_pdf`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: data.id }), // Ensure body is stringified
        });

        const responseData = await response.blob(); // Get response as Blob

        // Create a Blob URL
        const blobUrl = window.URL.createObjectURL(responseData);
        const filename = response.headers.get('Content-Disposition')?.split('filename=')[1] || 'null'; // Extract filename from Content-Disposition header

        // Create a temporary anchor element
        const tempAnchor = document.createElement('a');
        tempAnchor.href = blobUrl;
        tempAnchor.download = filename; // Set the filename for download

        // Programmatically click the anchor element to trigger download
        tempAnchor.click();

        // Remove the temporary anchor element
        tempAnchor.remove();
    };



    return (
        <div className="contentbar mb-3">
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-12 col-xl-12">
                    <div className="text-center mt-3 mb-5">
                        <h4>परिचय पत्रक</h4>
                    </div>
                </div>
            </div>

            <div className="row justify-content-center">

                <div className="col-md-12 col-lg-10 col-xl-10">
                    <div className="card m-b-30">
                        <div className="card-body">
                            <div className="invoice">
                                <div className="invoice-head">
                                    {fileGenerated ?
                                        <>
                                            <div className="row">
                                                <div className="col col-md-12 text-center">
                                                    <img src={imageUrl}
                                                        className="img-fluid border border-3 rounded-1 border-info"
                                                        alt="invoice-logo"
                                                        height={900}
                                                        width={600} />
                                                </div>
                                            </div>
                                            <div className="row justify-content-md-center mt-3">
                                                <div className="col col-md-3 text-center">
                                                    <button type="button"
                                                        className="btn btn-success btn-lg"
                                                        onClick={() => gettingGeneratedImage()}>
                                                        Download Image
                                                    </button>
                                                    &nbsp;&nbsp;
                                                    <button type="button"
                                                        className="btn btn-warning btn-lg"
                                                        onClick={() => gettingGeneratedPdf()}>
                                                        Download PDF
                                                    </button>
                                                </div>
                                            </div>
                                        </> :
                                        <div style={{ height: '800px', border: '1px solid black', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <p>Loading...</p>
                                        </div>}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Result;
